import enUS from 'antd/locale/en_US'
import zhCN from 'antd/locale/zh_CN'

import { ConfigProvider, App } from 'antd'
import { StyleProvider } from '@ant-design/cssinjs'

export default function (props) {
  const theme = React.useMemo(() => {
    return {
      token: {
        colorPrimary: `#ffd591`,
      }
    }
  }, [])

  return <ConfigProvider locale={zhCN} theme={theme}>
    <App>
      <StyleProvider hashPriority='high'>
        {props.children}
      </StyleProvider>
    </App>
  </ConfigProvider>
}
